import React from 'react';
import { Section, SectionTitle } from '@/components/shared/Section';
import { Bot } from 'lucide-react';

export default function VenddiScreenshots() {
  return (
    <Section alt>
      <SectionTitle
        badge="VENDDI EN VIVO"
        title="Así se ve desde adentro"
        subtitle="UI del kiosco + dashboard de operaciones + alertas de Kian."
        center
      />
      <div className="grid lg:grid-cols-2 gap-6 max-w-6xl mx-auto mt-8 min-w-0">
        {/* Dashboard */}
        <div className="relative">
          <div className="absolute -inset-4 bg-gradient-to-br from-[#0EA5E9]/20 to-transparent blur-2xl rounded-full" />
          <div className="relative rounded-2xl bg-[#0A2540] p-5 border border-white/10 shadow-2xl">
            <div className="flex items-center justify-between mb-4 pb-3 border-b border-white/10">
              <div>
                <div className="text-[10px] font-bold text-[#38BDF8] uppercase">Dashboard Operaciones</div>
                <div className="text-sm font-semibold text-white">Cadena piloto · kioscos multi-tienda</div>
              </div>
              <span className="text-[10px] text-emerald-400 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />LIVE</span>
            </div>
            <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-3">
              {[
                { v: '$12.4M', l: 'Ventas hoy', c: '#10B981' },
                { v: '3.847', l: 'Transacciones', c: '#0EA5E9' },
                { v: '$3.227', l: 'Ticket prom.', c: '#38BDF8' },
              ].map((k, i) => (
                <div key={i} className="p-2 sm:p-3 rounded-lg bg-white/5">
                  <div
                    className="text-xs sm:text-base lg:text-xl font-black leading-none tracking-tight"
                    style={{ color: k.c, fontFamily: 'Syne,sans-serif', fontVariantNumeric: 'tabular-nums' }}
                  >
                    {k.v}
                  </div>
                  <div className="text-[8px] sm:text-[9px] text-slate-400 uppercase tracking-wider mt-1.5 leading-tight">{k.l}</div>
                </div>
              ))}
            </div>
            <div className="relative h-28 rounded-lg bg-white/5 overflow-hidden p-3">
              <svg viewBox="0 0 200 80" className="w-full h-full" preserveAspectRatio="none">
                <polyline points="0,60 15,55 30,40 45,45 60,30 75,35 90,25 105,20 120,28 135,15 150,22 165,10 180,18 200,5" fill="none" stroke="#38BDF8" strokeWidth="2" />
                <polyline points="0,60 15,55 30,40 45,45 60,30 75,35 90,25 105,20 120,28 135,15 150,22 165,10 180,18 200,5 200,80 0,80" fill="url(#grad1)" opacity="0.3" />
                <defs><linearGradient id="grad1" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stopColor="#38BDF8" /><stop offset="1" stopColor="#38BDF8" stopOpacity="0" /></linearGradient></defs>
              </svg>
            </div>
          </div>
        </div>

        {/* Kiosco UI */}
        <div className="relative">
          <div className="absolute -inset-4 bg-gradient-to-br from-[#38BDF8]/20 to-transparent blur-2xl rounded-full" />
          <div className="relative rounded-2xl bg-white border-4 border-[#0A2540] p-4 shadow-2xl">
            <div className="text-center mb-3 pb-3 border-b border-slate-100">
              <div className="text-[9px] font-bold text-[#0EA5E9] uppercase tracking-wider">TU PEDIDO</div>
              <h3 className="text-base font-bold text-[#0A2540]" style={{ fontFamily: 'Syne,sans-serif' }}>Venddi Kiosco UI</h3>
            </div>
            <div className="grid grid-cols-3 gap-2 mb-3">
              {['Hamburguesa', 'Pizza', 'Ensalada', 'Jugo', 'Café', 'Postre'].map((p, i) => (
                <div key={i} className="aspect-square rounded-lg bg-gradient-to-br from-slate-100 to-slate-50 border border-slate-200 flex flex-col items-center justify-center p-2">
                  <div className="w-8 h-8 rounded-full bg-[#0EA5E9]/10 mb-1" />
                  <div className="text-[9px] font-semibold text-slate-700 text-center leading-tight">{p}</div>
                  <div className="text-[8px] text-[#0EA5E9] font-bold">$X.XXX</div>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-2 p-2.5 rounded-lg bg-[#38BDF8]/10 border border-[#38BDF8]/30 mb-3">
              <Bot className="w-4 h-4 text-[#0A2540]" />
              <span className="text-[10px] text-[#0A2540] font-semibold">Kian sugiere: combo por $500 menos</span>
            </div>
            <button className="w-full py-3 rounded-xl bg-[#10B981] text-white text-sm font-bold">Ir a pagar</button>
          </div>
        </div>
      </div>
    </Section>
  );
}
